import React, { useState, useEffect, useImperativeHandle, useRef } from 'react';
import './index.css'
import { Popconfirm,Textarea,  Tooltip } from 'tdesign-react';

// theme : primary | star
export default ({ currentKey,onChoose,keyPrompt = '',maxPrompt =128, setShowConfirm, keyVal, theme = 'primary', content, onClose, onConfirm, showSettings = false, hasAdvancedConfig = false, onSettings}) => {
  const [promt, setPromt] = useState(keyPrompt);

  // 当外部 keyPrompt 变化时（如通过抽屉更新），同步到本地状态
  useEffect(() => {
    setPromt(keyPrompt);
  }, [keyPrompt]);
  const TagContent = () => {
    return <>
      <h4 className="ocrDemo-popConfirm__title">提示词</h4>
      <p className="ocrDemo-popConfirm__describe">
        <Textarea
          placeholder="如需提升字段抽取效果；可以添加字段的描述，比如相近词、详细描述"
          value={promt}
          max={maxPrompt}
          rows={3}
          onChange={(value) => {
            setPromt(value);
          }}
          onBlur={() => {
            setShowConfirm(false)
          }}
        />
      </p>
    </>
  }

  return (<>
    <Popconfirm
      content={TagContent()}
      visible={keyVal === currentKey}
      icon={<></>}
      destroyOnClose
      placement="bottom"
      showArrow
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      onCancel={() => {
        setShowConfirm(false);
      }}
      onConfirm={() => {
        setShowConfirm(false);

        onConfirm({
          KeyPrompt: promt,
          keyName: content,
          Key:keyVal
        })
      }}
      theme="default">
      <span>
        <Tooltip theme="light" content={keyPrompt}>
          <div className={`ocrDemo-tag-container ${theme}`}
            onClick={(e) => {
              setShowConfirm(true);
              onChoose(keyVal)
            }}>
            <div className="ocrDemo-tag__border"></div>
            <div className="ocrDemo-tag__bg"></div>
            <div className="ocrDemo-tag__content">
              {content}
            </div>
            {showSettings && hasAdvancedConfig && (
              <div className="ocrDemo-tag__check" title="已配置高级字段"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="aqxcheck-circle"><path id="fill1" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z" fill="#00a870"/><path id="stroke1" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z" stroke-linecap="square" stroke-width="2" stroke="#00a870"/><path id="stroke2" d="M16.5 9L10.5 15L7.5 12" stroke-linecap="square" stroke-width="2" stroke="#ffffff"/></g></svg></div>
            )}
            {showSettings && (
              <div className="ocrDemo-tag__settings"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setShowConfirm(false);
                  onSettings && onSettings(keyVal, e);
                }}
                title="字段设置"
              >
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="csusetting-1"><path id="fill1" fill-rule="evenodd" clip-rule="evenodd" d="M9.40811 4.95996L10.0001 2H14.0001L14.5921 4.95996C15.4027 5.25851 16.1475 5.69306 16.7989 6.23595L19.6604 5.26796L21.6604 8.73206L19.3922 10.7254C19.4632 11.1396 19.5001 11.5655 19.5001 12C19.5001 12.4345 19.4632 12.8604 19.3922 13.2747L21.6604 15.268L19.6604 18.7321L16.7989 17.7641C16.1475 18.3069 15.4027 18.7415 14.5921 19.04L14.0001 22H10.0001L9.40811 19.04C8.5975 18.7415 7.85268 18.3069 7.20131 17.7641L4.33984 18.7321L2.33984 15.268L4.60798 13.2747C4.53705 12.8604 4.5001 12.4345 4.5001 12C4.5001 11.5655 4.53705 11.1396 4.60797 10.7254L2.33984 8.73206L4.33984 5.26796L7.20129 6.23595C7.85266 5.69306 8.59749 5.25851 9.40811 4.95996Z" fill="transparent"/><path id="fill2" d="M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z" fill="transparent"/><path id="stroke1" fill-rule="evenodd" clip-rule="evenodd" d="M9.40811 4.95996L10.0001 2H14.0001L14.5921 4.95996C15.4027 5.25851 16.1475 5.69306 16.7989 6.23595L19.6604 5.26796L21.6604 8.73206L19.3922 10.7254C19.4632 11.1396 19.5001 11.5655 19.5001 12C19.5001 12.4345 19.4632 12.8604 19.3922 13.2747L21.6604 15.268L19.6604 18.7321L16.7989 17.7641C16.1475 18.3069 15.4027 18.7415 14.5921 19.04L14.0001 22H10.0001L9.40811 19.04C8.5975 18.7415 7.85268 18.3069 7.20131 17.7641L4.33984 18.7321L2.33984 15.268L4.60798 13.2747C4.53705 12.8604 4.5001 12.4345 4.5001 12C4.5001 11.5655 4.53705 11.1396 4.60797 10.7254L2.33984 8.73206L4.33984 5.26796L7.20129 6.23595C7.85266 5.69306 8.59749 5.25851 9.40811 4.95996Z" stroke-linecap="square" stroke-width="1" stroke="#767a79"/><path id="stroke2" d="M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z" stroke-linecap="square" stroke-width="1" stroke="#767a79"/></g></svg>
            </div>
            )}
            <div className="ocrDemo-tag__close"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onClose(content, keyVal)
              }}
            ></div>
            {/* <div className="ocrDemo-tag__star" ></div> */}
          </div>
        </Tooltip>
      </span>
    </Popconfirm>
    {
      keyVal === currentKey && 
    <div className="ocrDemo-popconfirm-mask" onClick={() => {
      setShowConfirm(false);
    }}></div>

    }
  </>)
}